import { render, staticRenderFns } from "./normalTable.vue?vue&type=template&id=2187e614&scoped=true"
import script from "./normalTable.vue?vue&type=script&lang=js"
export * from "./normalTable.vue?vue&type=script&lang=js"
import style0 from "./normalTable.vue?vue&type=style&index=0&id=2187e614&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187e614",
  null
  
)

export default component.exports